import { render } from "./CitiesCarouselSection.vue?vue&type=template&id=06a2cafa&scoped=true"
import script from "./CitiesCarouselSection.vue?vue&type=script&lang=js"
export * from "./CitiesCarouselSection.vue?vue&type=script&lang=js"

import "./CitiesCarouselSection.vue?vue&type=style&index=0&id=06a2cafa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a2cafa"]])

export default __exports__